import { render } from "./LoseUpkeepAdd.vue?vue&type=template&id=fdb600e0"
import script from "./LoseUpkeepAdd.vue?vue&type=script&lang=js"
export * from "./LoseUpkeepAdd.vue?vue&type=script&lang=js"

import "./LoseUpkeepAdd.vue?vue&type=style&index=0&id=fdb600e0&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__